<template>
  <div class="invoice-page">
    <div class="invoice">
      <div class="invoice-header">
        <div class="invoice-header-con">
          <div class="invoice-header-title">
            <div class="header-title-con">
              开票金额
              <div class="price-small" style="margin-left: 5px">￥</div>
              <div class="header-price">
                <div class="price-big">{{initAmount(totalAmount).amountInteger}}</div>
                <div class="price-small">{{initAmount(totalAmount).amountDecimal}}</div>
              </div>
            </div>
            <img class="title-icon" @click="showInvoiceExplain" src="https://resource.rcclchina.com.cn/invoice/header-question.png" alt="">
          </div>
          <div class="header-tips">
            <div class="header-tips-item">{{invoiceCompany}}</div>
            <div class="header-tips-item">{{invoiceContent}}</div>
            <div class="header-tips-item">可开票金额为实际支付金额，不包括虚拟资产、礼品卡、会员积分券、红包、优惠券等支付金额</div>
          </div>
        </div>
      </div>
      <div class="invoice-con">
        <div class="invoice-info">
          <div class="invoice-info-con">
            <div class="invoice-info-title">
              01 填写发票信息
            </div>
            <div class="invoice-type">
              <div class="invoice-type-left">
                类型
              </div>
              <div class="invoice-type-right">
                <div>
                  增值税普通发票（电子发票）
                </div>
                <div class="right-tips">提交开票申请后1-5个工作日内推送至您的邮箱/手机号</div>
              </div>
            </div>
            <div class="invoice-type">
              <div class="invoice-type-left">
                拆分
              </div>
              <div class="invoice-type-right">
                <div class="invoice-num">
                  <img @click="reduceSplitCount" :src="`https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/${splitGuestCount>1 ? 'iconMinus' : 'iconMinusDisable' }.png`" alt="">
                  {{splitGuestCount}}张
                  <img @click="addSplitCount" :src="`https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/${splitGuestCount>=guestNumber ? 'iconPlusDisable' : 'iconPlus'}.png`" alt="">
                </div>
              </div>
            </div>
            <div v-for="(i,idx) in invoiceInfoList" :key="idx">
              <div class="invoice-type" v-if="invoiceInfoList.length===1">
                <div class="invoice-type-left">
                  抬头
                </div>
                <div class="invoice-type-right">
                  <div v-if="!i.customerName">
                    <div class="title-select" style="color: #bfbfbf" @click="addInvoiceInfo(idx)">
                      请选择发票抬头
                      <img class="title-select-img" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconArrowRight.png" alt="">
                    </div>
                    <div v-if="i.showInvoiceTitleMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入发票抬头</div>
                  </div>
                  <div v-else @click="addInvoiceInfo(idx)">
                    <div class="invoice-company">
                      <div class="invoice-company-title">
                        <div class="title-text">{{i.customerName}}</div>
                        <img v-if="i.businessType===1" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type1.png" alt="">
                        <img v-if="i.businessType===2" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type2.png" alt="">
                        <img v-if="i.businessType===3" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type3.png" alt="">
                      </div>
                      <img class="title-select-img" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconArrowRight.png" alt="">
                    </div>
                    <div v-if="i. nsrsbh" class="right-tips" style="padding: 0">税号:{{ i. nsrsbh}}</div>
                  </div>
                </div>
              </div>
              <div class="invoice-type invoiceSplit" v-else>
                <div class="invoice-type-left">
                  发票{{idx+1}}
                </div>
                <div class="invoice-type-right">
                  <div v-if="!i.customerName" class="invoice-type-con">
                    <div class="title-select" style="color: #bfbfbf" @click="addInvoiceInfo(idx)">
                      请选择发票抬头
                      <img class="title-select-img" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconArrowRight.png" alt="">
                    </div>

                    <div v-if="i.showInvoiceTitleMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入发票抬头</div>
                  </div>
                  <div v-else @click="addInvoiceInfo(idx)" class="invoice-type-con">
                    <div class="invoice-company">
                      <div class="invoice-company-title">
                        <div class="title-text">{{i.customerName}}</div>
                        <img v-if="i.businessType===1" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type1.png" alt="">
                        <img v-if="i.businessType===2" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type2.png" alt="">
                        <img v-if="i.businessType===3" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type3.png" alt="">
                      </div>
                      <img class="title-select-img" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconArrowRight.png" alt="">
                    </div>
                    <div v-if="i. nsrsbh" class="right-tips" style="padding: 0">税号:{{ i. nsrsbh}}</div>
                  </div>
                  <div class="invoice-item-price">
                    金额
                    <div>
                      <span style="color: #CFCFCF;">￥-</span>
                      <input type="number"
                              placeholder="请输入开票金额"
                              @input="inputAmount(idx)"
                              @blur="inputBlur(idx)"
                              v-model="i.amount"
                              step="0.01">
                    </div>
                 </div>
                  <div v-if="i.showInvoiceMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">{{ i.invoiceMsg }}</div>
                  <div v-if="i.showInvoiceAmountMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入开票金额</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-receive">
          <div class="invoice-receive-con">
            <div class="invoice-receive-title">
              02 填写接收信息
            </div>
            <div class="invoice-receive-type" @click="showReceiveInfo" v-if="!receiveInfo">
              <img class="type-select-img" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconAddForm.png" alt="">
              <div class="title-select" style="color: #bfbfbf">
                <div class="info-tips">
                  <div>添加接收信息</div>
                  <div v-if="isShowReceiveInfoMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入接收信息</div>
                </div>
              </div>
            </div>
            <div class="invoice-receive-type" @click="showReceiveInfo" v-else>
              <img class="type-select-img" @click.stop="delReceiveInfo" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconMinus.png" alt="">
              <div class="title-select" style="color: #bfbfbf">
                <div class="info-tips" style="color: #202020;justify-content: space-between">
                  <div>{{receiveType===1 ? '邮箱：':'手机：'}}{{ receiveInfo }}</div>
                  <div class="info-tips-icon">
                    <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconEditInfo.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div @click="showOnlineService" class="relation-service"><img src="https://resource.rcclchina.com.cn/invoice/kefu.png" alt="">如有疑问请联系在线客服</div>
        </div>
        <div class="submit-invoice" @click="submitInvoice">
          <div class="submit-invoice-btn">
            提交
          </div>
        </div>
      </div>
    </div>
    <div class="split-tips" v-if="isSplitUpper">本单最多可拆分{{guestNumber}}张</div>
    <invoice-from :onGoBack="closeCancelPolicyPopup"
                  :isShow="isShowAddInvoice"
                  :currentInvoice="currentInvoice"
                  @saveInvoice="saveInvoice"
                  :isEditInvoice="isEditInvoice"
    ></invoice-from>
    <BottomPopup :show="isShowReceiveInfo"
                  title="填写接收信息"
                  @close="closeBottomPolicyPopup"
    >
      <div class="addInvoice-con receive-info" v-if="true">
        <div class="addInvoice-main">
          <div class="addInvoice-form">
            <div class="addInvoice-item">
              <div class="addInvoice-item-title">选择方式：</div>
              <div class="addInvoice-item-content">
                <div class="receive-tab-item" :class="{active : receiveType===1}" @click="changeReceiveType(1)">
                  邮箱
                </div>
                <div class="receive-tab-item" :class="{active : receiveType===2}" @click="changeReceiveType(2)">
                  手机号
                </div>
              </div>
            </div>
            <div class="addInvoice-item" v-if="receiveType===1">
              <div class="addInvoice-item-title">邮箱地址：</div>
              <div class="addInvoice-item-content" style="margin: 15px 0;">
                <input type="text" v-model="receiveInfoValue" placeholder="邮箱地址为必填">
              </div>
            </div>
            <div class="addInvoice-item"  v-if="receiveType===2">
              <div class="addInvoice-item-title">手机号：</div>
              <div class="addInvoice-item-content" style="margin: 15px 0;">
                <input type="text" v-model="receiveInfoValue" placeholder="手机号为必填">
              </div>
            </div>
            <div class="receiveInfo-tips">
              <div v-if="verifyReceiveFormMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">{{verifyReceiveFormMsg}}</div>
            </div>
            <div class="addInvoiceBtn" @click="saveReceiveInfo">提交</div>
          </div>
        </div>
      </div>
    </BottomPopup>
    <BottomPopup :show="isShowInvoiceExplain"
                 :title="invoiceDesctTitleOfPopuo"
                 @close="isShowInvoiceExplain=false"
    >
      <div class="addInvoice-form invoice-explain">
        <!-- <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/invoiceDescPopupContent.jpg" alt=""> -->
        <div v-html="invoiceDescContentOfPopuo"></div>
      </div>
    </BottomPopup>
  </div>
</template>
<script>
import api from "@/api";
import InvoiceFrom from "@/components/Booking/InvoiceFrom.vue";
import BottomPopup from "@/components/Booking/BottomPopup.vue";
import {jumpOnlineService} from "@/utilities/common";

export default {
  components: {BottomPopup, InvoiceFrom},
  data () {
    return {
      invoiceInfoType:1,  //开票类型 目前默认1
      totalAmount:0,  //金额
      splitGuestCount:1,  // 拆分数量
      guestNumber:2,  // 乘客人数
      invoiceCompany:'开票方为皇家加勒比游轮船务（中国）有限公司',
      invoiceContent:'旅游服务*代订住宿费',
      isSplitUpper:false,
      invoiceInfoList:[
        {
          businessType: 2,
          customerName: "",
          amount: null,
          nsrsbh: "",
          customerAddress: "",
          customerPhone: "",
          customerBankName: "",
          customerBankCard: "",
          verifyInfoMsg: "",
          showInvoiceAmountMsg: false,
          showInvoiceTitleMsg:false
        }
      ],
      isShowAddInvoice:false,
      currentInvoice:null, // 发票信息
      isShowInvoiceTips:false,  // 显示发票未填写时提示
      isShowReceiveInfo:false,  //显示接收信息
      receiveType:1, //接收信息类型 1邮箱 2手机
      receiveInfo:'',  // 接收信息内容
      isShowReceiveInfoTips:false,
      isShowReceiveInfoMsg:false,
      businessList:null,  // 公司列表
      allowBusinessSearch:false,
      showBusinessList:false,
      bookingRecordIds:'',
      isShowNsrsbn:false,
      isShowInvoiceType:false,
      invoiceTypeInfo:{},  // 弹窗文案
      invoiceApplyId:'',  // 开票后才会有值
      invoiceType:1,
      receiveInfoValue:'',
      verifyReceiveFormMsg:'',
      ApplyBookingRecordIds:null,
      isShowInvoiceExplain:false,
      isEditInvoice:false,
      invoiceDescContentOfPopuo:'',
      invoiceDesctTitleOfPopuo:'',
    }
  },
  mounted(){
    this.initPage()
    this.getInvoiceDescContent()
  },
  beforeMount () {
    this.$store.commit('SET_PAGE_TITLE', '发票')
    this.$store.dispatch('HIDE_HEADER_BAR', {isHideHeader: false, isHideFooter: true})
  },
  methods: {
    // 获取发票说明
    async getInvoiceDescContent(){
      const { success, data } = await api.page.getContentByKey({
        key: "INVOICE_DESCPOPUP_CONTENT",
      });
      if (success && data) {
        this.invoiceDescContentOfPopuo = data.content;
        this.invoiceDesctTitleOfPopuo = data.title;
      }
    },
    initPage(){
      let query = this.$route.query
      this.bookingRecordIds = query.bookingRecordIds
      this.invoiceApplyId = query.invoiceApplyId
      if(query.invoiceApplyId && query.invoiceApplyId!==''){  // 代表重新开票
        this.invoiceApplyId = query.invoiceApplyId
        this.invoiceType = 2
        // this.getInvoiceInfo()
      }else{
        this.invoiceType = 1
        this.invoiceApplyId = ''
      }
      this.getBookingAmount()
    },
    reduceSplitCount(){
      if(this.splitGuestCount>1){
        this.splitGuestCount--
        if(this.invoiceInfoList.length>0){
          this.invoiceInfoList.splice(this.invoiceInfoList.length-1, 1)
        }
        if(this.invoiceInfoList.length===1){
          this.invoiceInfoList[0].amount = null
        }
      }
    },
    addSplitCount(){
      if(this.isSplitUpper) return
      if(this.splitGuestCount < this.guestNumber){
        this.invoiceInfoList.push({
          businessType: 2,
          customerName: "",
          amount: null,
          nsrsbh: "",
          customerAddress: "",
          customerPhone: "",
          customerBankName: "",
          customerBankCard: "",
          remark: "",
          verifyInfoMsg: "",
          showInvoiceAmountMsg: false,
        })
        this.splitGuestCount++
      }else{
        this.isSplitUpper = true
        setTimeout(()=>{
          this.isSplitUpper = false
        },1500)
      }
    },
    // 添加发票信息
    addInvoiceInfo(idx){
      this.currentInvoice = { ...this.invoiceInfoList[idx], index: idx }
      this.isShowAddInvoice = true
      console.log('currentInvoice', this.currentInvoice)
    },
    // 发票金额
    inputAmount(index){
      let amountSum = 0;
      let lastIndex = this.invoiceInfoList.length - 1;
      if(index < lastIndex) {
        let invoiceInfoList = this.invoiceInfoList;
        let amountSumLast = 0;
        let sumCount = 0;
        invoiceInfoList && invoiceInfoList.forEach((invoice,idx)=> {
          if(idx < lastIndex && invoice.amount) {
            amountSumLast += parseFloat(invoice.amount);
            sumCount++;
          }
        });
        let amountLast = 0;
        if(amountSumLast < this.totalAmount) {
          amountLast = (this.totalAmount - amountSumLast).toString();
        }
        if(sumCount < (this.invoiceInfoList.length - 1)) {
          amountLast = null;
        }
        if(amountLast && amountLast.indexOf('.') === -1) {
          amountLast = amountLast + '.00'
        }
        this.invoiceInfoList[lastIndex].amount = amountLast
      }
      this.invoiceInfoList && this.invoiceInfoList.forEach((invoice)=> {
        if(invoice.amount) {
          amountSum += parseFloat(invoice.amount);
        }
      });
      this.invoiceInfoList && this.invoiceInfoList.forEach((invoice)=> {
        invoice.showInvoiceMsg = false;
      })
      if(amountSum < this.totalAmount) {
        this.invoiceInfoList[index].showInvoiceMsg = true;
        this.invoiceInfoList[index].showInvoiceAmountMsg = false
        this.invoiceInfoList[index].invoiceMsg = "拆分金额总和不足可开票金额总和";
      } else if(amountSum > this.totalAmount) {
        this.invoiceInfoList[index].showInvoiceMsg = true;
        this.invoiceInfoList[index].showInvoiceAmountMsg = false
        this.invoiceInfoList[index].invoiceMsg = "拆分金额超限额，请重新输入";
      }
    },
    inputBlur(index){
      let amount = String(this.invoiceInfoList[index].amount);
      if(amount && amount.indexOf('.') === -1) {
        amount = amount + '.00'
      }
      this.invoiceInfoList[index].amount = amount;
    },
    showReceiveInfo(){
      this.isShowReceiveInfo = true
    },
    delReceiveInfo(){
      this.receiveInfo = ''
      this.receiveInfoValue = ''
    },
    // 保存接收信息
    saveReceiveInfo(){
      // 验证邮箱
      this.verifyReceiveFormMsg = ''
      if(this.receiveType===1){
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if(this.receiveInfoValue.trim()===''){
          this.verifyReceiveFormMsg = '请填写邮箱地址'
        }else{
          if(!reg.test(this.receiveInfoValue)){
            this.verifyReceiveFormMsg = '请填写正确的邮箱地址'
          }
        }
      }else{  // 验证手机号
        let reg = /^1[3456789]\d{9}$/
        if(this.receiveInfoValue.trim()===''){
          this.verifyReceiveFormMsg = '请填写手机号'
        }else{
          if(!reg.test(this.receiveInfoValue)){
            this.verifyReceiveFormMsg = '请填写正确的手机号'
          }
        }
      }
      if(this.verifyReceiveFormMsg!=='') return
      this.receiveInfo = this.receiveInfoValue
      this.isShowReceiveInfo = false
    },
    // 获取订单价格和乘客人数
    async getBookingAmount() {
      this.$loading.show();
      // 改为encBookingRecordIds
      let {success, data, errMsg} = await api.booking.getBookingAmount({encBookingRecordIds: this.bookingRecordIds})
      this.$loading.hide();
      if(success){
        this.totalAmount = data.invoiceAmount
        this.guestNumber = data.guestNumber
        this.invoiceCompany = data.invoiceCompany
        this.invoiceContent = data.invoiceContent
        this.ApplyBookingRecordIds = data.invoiceApplyBookingRecordIds
      }else{
        this.$alert.show(errMsg);
      }
    },
    // 联系在线客服
    showOnlineService() {
      jumpOnlineService();
    },
    showTypeExplain(){
      this.isShowInvoiceType = !this.isShowInvoiceType
      this.isShowNsrsbn = false
    },
    showNsrsbhExplain(){
      this.isShowInvoiceType = false
      this.isShowNsrsbn = !this.isShowNsrsbn
    },
    // 点击提交时更改价格属性移除小数点后为00的
    setAmount(e){
      if(e && e.toString().indexOf('.00')>=0){
        return Number(e.toString().replace('.00',''))
      }
      return e
    },
    // 获取发票信息 重开发票时调用
    async getInvoiceInfo() {
      let params = {
        invoiceApplyId: this.invoiceApplyId,
        userName:this.$store.state.user.userToken
      }
      this.$loading.show()
      let {success, data, errMsg} = await api.booking.getBookingRecordInvoice(params)
      this.$loading.hide()
      if(success){
        this.invoiceInfoList = []
        this.totalAmount = 0
        let invoiceList = data.invoiceApplyOrderList
        invoiceList.forEach((i)=>{
          if(i.amount%1===0){
            i.amount = i.amount+'.00'
          }
          this.invoiceInfoList.push({
            businessType: i.businessType,
            customerName: i.gmfMc,
            amount: i.amount,
            nsrsbh: i.gmfNsrsbh,
            customerAddress: i.gmfDz,
            customerPhone: i.gmfDh,
            customerBankName: i.gmfYh,
            customerBankCard: i.gmfZh,
          })
          this.totalAmount += Number(i.amount)
        })
        this.receiveInfoValue = invoiceList[0].gmfMobile || invoiceList[0].gmfEmail
        this.splitGuestCount = invoiceList.length
        this.receiveInfo = invoiceList[0].gmfMobile || invoiceList[0].gmfEmail
        this.receiveType = invoiceList[0].gmfMobile ? 2 : 1
      }else{
        this.$alert.show(errMsg);
      }
    },
    //开发票
    async submitInvoice() {
        let isOkNum = 0;
        let amountSum = 0;
        let invoiceList = [];

        if (this.invoiceInfoList.length === 1) {
          this.invoiceInfoList[0].amount = this.totalAmount;
          if(!this.invoiceInfoList[0].customerName || this.invoiceInfoList[0].customerName === ''){
            this.invoiceInfoList[0].showInvoiceTitleMsg = true;
            isOkNum++;
          }
          if(!this.invoiceInfoList[0].amount || this.invoiceInfoList[0].amount == 0){
            this.invoiceInfoList[0].showInvoiceAmountMsg = true;
            this.invoiceInfoList[0].showInvoiceMsg = false;
            isOkNum++;
          }
          if (!this.receiveInfo || this.receiveInfo === '') {
            this.isShowReceiveInfoMsg = true;
            isOkNum++;
          }
          amountSum = this.setAmount(this.invoiceInfoList[0].amount);
          this.invoiceInfoList.forEach((invoice) => {
            invoiceList.push({
              businessType: invoice.businessType,
              amount: this.setAmount(invoice.amount),
              customerName: invoice.customerName.trim(),
              nsrsbh: invoice.nsrsbh.trim(),
              customerAddress: invoice.customerAddress.trim(),
              customerPhone: invoice.customerPhone.trim(),
              customerBankName: invoice.customerBankName.trim(),
              customerBankCard: invoice.customerBankCard.trim(),
            });
          })
        }else{
          this.invoiceInfoList.forEach((invoice) => {
            if (!invoice.customerName || invoice.customerName === '') {
              invoice.showInvoiceTitleMsg = true;
              isOkNum++;
            }

            if (!invoice.amount || invoice.amount === 0) {
              invoice.showInvoiceAmountMsg = true;
              invoice.showInvoiceMsg = false;
              isOkNum++;
            }

            if (!this.receiveInfo || this.receiveInfo === '') {
              this.isShowReceiveInfoMsg = true;
              isOkNum++;
            }

            if (invoice.amount) {
              amountSum += parseFloat(invoice.amount);
            }

            invoiceList.push({
              businessType: invoice.businessType,
              amount: this.setAmount(invoice.amount),
              customerName: invoice.customerName.trim(),
              nsrsbh: invoice.nsrsbh.trim(),
              customerAddress: invoice.customerAddress.trim(),
              customerPhone: invoice.customerPhone.trim(),
              customerBankName: invoice.customerBankName.trim(),
              customerBankCard: invoice.customerBankCard.trim(),
            });
          });
        }

        console.log(amountSum , this.totalAmount)
        if (amountSum != this.totalAmount) {
          isOkNum++;
        }

        if (isOkNum > 0) return;
      let params = {
        ChannelCode:'1',
        Type:invoiceList.length>1 ? 2 : 1,
        Mobile:this.receiveType===2 ? this.receiveInfo : '',
        Email:this.receiveType===1 ? this.receiveInfo : '',
        InvoiceType:this.invoiceType,
        ReopenInvoiceApplyId:this.invoiceApplyId,
        InvoiceApplySplitReqDetail:invoiceList,
        BookingRecordIds: this.ApplyBookingRecordIds?.map(item => {
           return {
            encBookingRecordId: item.encBookingRecordId,
            amount:item.amount
          }
        })
      }
      // console.log('params',params)
      let {success,data, errMsg} = await api.booking.submitInvoice(params)
      if(success){
        await this.$router.push({
          path: '/Rccl.Booking/Booking/InvoiceDetailsProgress',
          query: {
            invoiceApplyId: data.invoiceApplyId,
          }
        })
      }else{
        this.$alert.show(errMsg);
      }
    },
    closeCancelPolicyPopup(){
      this.isShowAddInvoice = false
    },
    saveInvoice(currentInvoice,index){
      this.isShowAddInvoice = false
      this.isEditInvoice = true
      this.invoiceInfoList[index] = currentInvoice
      console.log(this.invoiceInfoList)
    },
    closeBottomPolicyPopup(){
      this.isShowReceiveInfo = false
    },
    changeReceiveType(type){
      this.receiveType = type
    },
    initAmount(i) {
      let amountArr = i.toString().split('.');
      let amountInteger = "0";
      let amountDecimal = ".00";
      if(i) {
        if(amountArr.length === 2) {
          amountInteger = amountArr[0];
          amountDecimal = '.'+amountArr[1];
        } else {
          amountInteger = amountArr[0];
        }
      }
      return {
        amountInteger,
        amountDecimal
      }
    },
    showInvoiceExplain(){
      this.isShowInvoiceExplain = true
    }
  },
  computed: {

  }
}
</script>
<style lang="less" scoped>
.invoice-page{
  background-color: #f5f5f5;
  position: relative;
  padding-bottom: 27px;
  height: calc(100vh - 74px);
  overflow: auto;
  .invoice{
    width: 100%;
    margin: 0 auto;
    padding-bottom: 27px;
    background-color: #fff;
    .invoice-header{
      width: 100%;
      height: 153px;
      display: flex;
      align-items: center;
      padding: 0 22px 0 17px;
      box-sizing: border-box;
      background: linear-gradient(225deg, #00aeea, #006ab6);
      .invoice-header-con{
        font-size: 16px;
        color: #fffefe;
        .invoice-header-title{
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 21px;
          .header-title-con{
            display: flex;
            align-items: baseline;
            .price-small{
              font-size: 12px;
            }
            .header-price{
              font-size: 16px;
              display: flex;
              align-items: baseline;
            }
          }
          .title-icon{
            width: 16px;
            height: 16px;
            display: block;
          }
        }
        .header-tips{
          font-size: 12px;
          margin-top: 5px;
          .header-tips-item{
            position: relative;
            padding-left: 17px;
            margin-bottom: 4px;
          }
          .header-tips-item::after{
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            background: #fff;
            border-radius: 50%;
            position: absolute;
            top: 10px;
            left: 0;
            transform: translate(0,-50%);
          }
        }
      }
    }
    .invoice-con{
      width: 100%;
      border-radius: 10px 10px 0 0;
      position: absolute;
      left: 0;
      top: 145px;
      z-index: 9;
      background-color: #F6F6F6;
      margin-bottom: 9px;
      overflow: auto;
      .invoice-info{
        padding: 13px 15px 0;
        width: 100%;
        box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
        margin-bottom: 9px;
        background-color: #fff;
        border-radius: 10px 10px 0 0;
        overflow:hidden;
        .invoice-info-con{
          width: 100%;
          margin: 0 auto;
          .invoice-info-title{
            font-size: 16px;
            font-weight: bold;
            color: #333333;
          }
          .invoice-type:last-child{
            //border-bottom: none;
          }
          .invoice-type{
            width: 100%;
            display: flex;
            font-size: 14px;
            border-bottom: 1px #EDEDED solid;
            margin: 0 auto;
            padding: 10px 0;
            .invoice-type-left{
              color: #999999;
              width: 75px;
              text-align: left;
            }
            .invoice-type-right{
              width:calc(100% - 75px);
              color: #202020;
              cursor: pointer;
              .invoice-type-con{
                padding-bottom: 10px;
                border-bottom: 1px solid #EDEDED;
              }
              .right-tips{
                //padding-left: 27px;
                font-size: 10px;
                color: #999999;
              }
              .invoice-num{
                font-size: 14px;
                display: flex;
                align-items: center;
                gap: 11px;
                img{
                  display: block;
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                }
              }
              .title-select{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: calc(100% - 14px);
                position: relative;
                .title-select-img{
                  width: 11px;
                  height: 11px;
                }
              }
              .invoice-company{
                display: flex;
                align-items: center;
                cursor: pointer;
                width: calc(100% - 14px);
                justify-content: space-between;
                .invoice-company-title{
                  display: flex;
                  align-items: center;
                  gap: 5px;
                  width: 100%;
                  .title-text{
                    width: calc(100% - 27px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .invoice-mark{
                    display: block;
                    height: 17px;
                  }
                }
                .title-select-img{
                  width: 11px;
                  height: 11px;
                }
              }
              .invoice-item-price{
                display: flex;
                align-items: center;
                gap: 20px;
                font-size: 14px;
                margin-top: 16px;
                position: relative;
                input{
                  width: 100px;
                  height: 20px;
                  font-style: normal;
                  font-size: 14px;
                  border: none;
                  margin-left: 5px;
                  color: #1C6AB6;
                  //font-weight: bold;
                }
                ::-webkit-input-placeholder {
                  color: #CFCFCF;
                }
              }
            }
          }
          .invoiceSplit{
            border-bottom: 1px solid #eee;
          }
        }
      }
      .invoice-receive{
        width: 100%;
        margin: 0 auto;
        background-color: #fff;
        padding: 13px 15px 12px;
        .invoice-receive-title{
          font-size: 16px;
          font-weight: bold;
          color: #282828;
        }
        .invoice-receive-type{
          padding: 10px 0;
          margin-top: 6px;
          display: flex;
          align-items: center;
          font-size: 14px;
          width: 100%;
          border-bottom: 1px #eee solid;
          position: relative;
          cursor: pointer;
          .type-select-img{
            width: 16px;
            height: 16px;
          }
          .title-select{
            padding-left: 14px;
            width: calc(100% - 17px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            .info-tips{
              display: flex;
              align-items: center;
              gap: 0 24px;
              padding-right: 6px;
              width: 100%;
              .info-tips-icon{
                width: 20px;
                height: 20px;
                img{
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .title-select-img{
              width: 11px;
              height: 11px;
            }
          }
        }
      }
      .relation-service{
        color: #0083C9;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        width: 100%;
        padding: 11px 0 100px 15px;
        cursor: pointer;
        text-decoration: #3f8fc7 underline;
        img{
          width: 16px;
          height: 17px;
        }
      }
      .submit-invoice{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 74px;
        font-size: 14px;
        text-align: center;
        color: #fff;
        background-color: #fff;
        padding: 18px 15px;
        cursor: pointer;
        .submit-invoice-btn{
          width: 345px;
          height: 39px;
          line-height: 39px;
          background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
          border-radius: 4px;
        }
      }
    }
    .noFilled{
      display: flex;
      align-items: center;
      font-size: 10px;
      line-height: 14px;
      gap: 5px;
      color: #fe0000;
      margin-top: 3px;
      img{
        display: block;
        width: 12px;
        height: 12px  ;
      }
    }
  }
  .split-tips{
    width: 156px;
    height: 46px;
    background: rgba(0,0,0,0.6);
    border-radius: 5px;
    text-align: center;
    line-height: 46px;
    color: #fff;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 9;
  }
  .addInvoice-con {
    width: 100%;
    height: 100%;;
    display: flex;
    align-items: center;
    justify-content: center;

    .addInvoice-main {
      width: 100%;
      background-color: #fff;

      .addInvoice-title {
        font-size: 17px;
        font-weight: bold;
        color: #333333;
        text-align: center;
        padding: 8px 0;
        border-bottom: 1px solid #d9d9d9;
        position: relative;

        .popup-close {
          width: 25px;
          height: 25px;
          position: absolute;
          padding: 5px;
          right: 14px;
          top: 14px;
          cursor: pointer;
        }
      }

      .addInvoice-form {
        padding: 10px 0 0;
        .addInvoice-item {
          display: flex;
          align-items: center;
          position: relative;
          border-bottom: 1px solid #eee;

          .addInvoice-item-title {
            font-size: 14px;
            color: #282828;
            text-align: left;
            position: relative;

            img {
              width: 17px;
              height: 17px;
              margin-left: 5px;
              cursor: pointer;
            }
          }

          .addInvoice-item-content {
            width: 100%;
            justify-content: space-evenly;
            display: flex;
            align-items: center;
            position: relative;
            gap: 46px;
            font-size: 14px;

            .receive-tab-item {
              padding: 9px 0;
            }

            .active {
              border-bottom: #F8C533 solid 2px;
            }
            input[type="text"] {
              width: 100%;
              height: 31px;
              border: none;
              font-style: normal;
              font-size: 14px;
              color: #000000;
            }

            //  设置input的placeholder颜色
            ::placeholder {
              color: #D0D0D0;
            }
          }

          .invoiceTypePopup {
            width: 549px;
            height: auto;
            position: absolute;
            top: 40px;
            background-color: rgba(32, 32, 32, 0.7);
            color: #ffffff;
            font-size: 18px;
            border-radius: 20px;
            padding: 17px 30px;
            z-index: 9;

            .nsrsbh-con {
              .nsrsbh-type {
                font-size: 22px;
                font-weight: bold;
                margin-bottom: 20px;
              }

              .nsrsbh-con-item {
                position: relative;
                padding-left: 10px;
              }
            }

            .tips-dot {
              position: absolute;
              top: 13px;
              left: 0;
              transform: translate(-50%, -50%);
              display: block;
              width: 5px;
              height: 5px;
              background: #fff;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
        .form-tips {
          font-size: 12px;
          color: #202020;
          width: 100%;
          margin-top: 8px;
          padding-left: 126px;
        }
        .receiveInfo-tips {
          height: 20px;
          margin: 26px 0 8px;
          font-size: 10px;
          .noFilled{
            display: flex;
            align-items: center;
            gap: 5px;
            color: #fe0000;
            justify-content: center;
            img{
              display: block;
              width: 14px;
              height: 14px  ;
            }
          }
        }
        .addInvoiceBtn{
          width: 345px;
          height: 39px;
          background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          line-height: 39px;
          text-align: center;
          color: #fff;
          margin: 0 auto 12px;
          cursor: pointer;
        }
      }
    }
  }
  .receive-info{
    padding:  0 15px;
    .addInvoice-form{
    }
    .addInvoice-item-title{
      width: 100px !important;
    }
  }
}
.invoice-radio{
  margin-bottom: 0;
  font-weight: 400;
  display: flex;
  align-items: center;
  cursor: pointer;
  input{
    margin: 0 12px 0 0;
  }
}
/*单选框基本（未选中）的样式*/
.invoice-radio input[type="radio"]{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-size: 100% auto;
  box-sizing:border-box;
  border:solid 1px #fcc300;
}
/*单选按钮选中后增加的样式*/
.invoice-radio input[type="radio"]:checked:before {
  content: "";
  display: block;
  width: 9px;
  height: 9px;
  margin: 2px;
  border-radius: 10px;
  background-color: #fcc300;
}
.invoice-explain{
  width: 100%;
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px 20px !important;
  //margin-top: 18px;
  border-top: 1px solid #F7F7F7;

  /deep/ p{
    margin: 0;
    font-size: 13px;
  }

  /deep/ .yellow-line{
    text-indent: 12px;
    position: relative;
    margin-bottom: 12px;
    font-size: 15px;
    line-height: 24px;
  }
 /deep/ .yellow-line::after{
  content: '';
  width: 4px;
  height: 14px;
  background-color: #fcc300;
  position: absolute;
  left: 0;
  top: 5px;
  }

 /deep/ .p-title{
    margin-top: 12px;
    margin-bottom: 4px;
  }

 /deep/ .yellow-dot{
    text-indent: 12px;
    position: relative;
    line-height: 20px;
  }
 /deep/ .yellow-dot::after{
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #fcc300;
    position: absolute;
    left: 0;
    top: 8px;
  }

 /deep/ .grey-line{
    width: 100%;
    height: 1px;
    background-color: #f7f7f7;
    margin: 14px 0;
    box-sizing: border-box;
  }
}
</style>